import PropTypes from "prop-types";

const pricingFeatureInterface = {
  baseQuantity: PropTypes.number, // 0
  comparisonFor: PropTypes.string, // "material"
  comparisonType: PropTypes.string, // "gte"
  cost: PropTypes.number, // 1
  costplus: PropTypes.number, // 1
  defaultQuantity: PropTypes.number, // 1
  displayName: PropTypes.string, // "Countertop Support Bracket"
  employeesOnly: PropTypes.bool,
  fabricatorBaseQuantity: PropTypes.number, // 0
  fabricatorComparisonFor: PropTypes.string, // "material"
  fabricatorComparisonType: PropTypes.string, // "gte"
  fabricatorCost: PropTypes.number, // 1.25
  fabricatorCostplus: PropTypes.number, // 1.25
  fabricatorFeatureIds: PropTypes.arrayOf(PropTypes.number), // !! [149793864]
  fabricatorMaxQuantity: PropTypes.number, // 0
  fd_Description: PropTypes.string, // "Attachment - 7018018White 0 0 31 imported from KVManager"
  fd_Enabled: PropTypes.bool,
  fd_MetaData: PropTypes.string, // "{\"RoomLayout\":[\"1\"],\"MatchingFeature\":[\"7018018\"],\"Filters\":null}"
  fd_Unit: PropTypes.string, // "Each"
  featureDefinition_id: PropTypes.number, // !! 1533825
  ff_Enabled: PropTypes.bool,
  ff_HideFromShopingCartOnKV: PropTypes.bool,
  flags: PropTypes.string,
  galleryEnabled: PropTypes.bool,
  groupName: PropTypes.string, // "Attachment"
  hideFromKitchenVisualizer: PropTypes.bool,
  hideQuantity: PropTypes.bool,
  hideUnitLabel: PropTypes.bool,
  imageKey: PropTypes.string, // "env_QKBStaging_f27bf694-9df0-4253-9e2c-5025d4d54103"
  isBundle: PropTypes.bool,
  maxQuantity: PropTypes.number, // 0
  model: PropTypes.string, // ""
  notTaxable: PropTypes.bool,
  orderId: PropTypes.number,
  price: PropTypes.number,
  productNotForSale: PropTypes.bool,
  showCostInFrontEnd: PropTypes.bool,
  showDescriptionTooltip: PropTypes.bool,
  sku: PropTypes.string, // "CTB"
  staticName: PropTypes.string, // "Cutting Board"
  subDescription: PropTypes.string, // "Need minimum 2 brackets\nadd one every 24 in."
  unlocked: PropTypes.bool,
  useStonePricing: PropTypes.bool,
}

export default pricingFeatureInterface
